import API from "serviceshift-ui/api-client";

import type { InventoryLocation, InventoryProduct } from "@/typings/inventory";
import type { InventoryUsage } from "@/typings/invoice";

export default {
  async fetchInventoryLocations({ commit }): Promise<InventoryLocation[]> {
    const res = await API.makeRequest("/admin/v4/inventory/locations");
    commit("replace", { state: "inventoryLocations", data: res.data.data });
    return res.data.data;
  },

  async fetchInventoryParts(
    _context,
    { search }: { search?: string } = {}
  ): Promise<InventoryProduct[]> {
    const params: Record<string, unknown> = {};
    if (search) params.filter = { search };

    const res = await API.makeRequest("/admin/v4/inventory/products", {
      params
    });
    return res.data.data;
  },

  async fetchInventoryInvoiceProductUsage(
    _context,
    { url }: { url: string }
  ): Promise<{
    invoice_id: number;
    default_inventory_location_id: number | null;
    inventory_usages: InventoryUsage[];
  }> {
    const res = await API.makeRequest(url);
    return res.data.data;
  }
};
